import { render } from "./StandardsHolder.vue?vue&type=template&id=854f010a&scoped=true&ts=true"
import script from "./StandardsHolder.vue?vue&type=script&lang=ts"
export * from "./StandardsHolder.vue?vue&type=script&lang=ts"

import "./StandardsHolder.vue?vue&type=style&index=0&id=854f010a&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-854f010a"]])

export default __exports__